import { QuestionMarkIcon } from 'src/assets/svg/question-mark-icon';
import styles from './recover-or-reset.module.scss';
import { useEffect, useState } from 'react';
import { LoginSteps } from '../../common/common-types';

type RecoverOrResetProps = {
	copmanyName: string;
	setComponent: (component: string) => void;
};

const RecoverOrReset = ({ copmanyName, setComponent }: RecoverOrResetProps) => {
	const [currentStep, setCurrentStep] = useState<LoginSteps>(LoginSteps.RecoverOrResetConfirmation);
	
	useEffect(() => {
		if (currentStep === LoginSteps.EnterEmail) {
			window.history.replaceState({ step: currentStep }, '');
			setComponent('login');
		} else if (window.history.state?.step !== currentStep) {
			window.history.pushState({ step: currentStep }, '');
		}
	}, [currentStep]);

	useEffect(() => {
		const handleBack = (event: PopStateEvent) => {
			if (event.state?.step == LoginSteps.EnterEmail) {
				setCurrentStep(event.state.step as LoginSteps);
				window.history.pushState(null, '', window.location.pathname);
			} else if (event.state?.step) {
				setCurrentStep(event.state.step as LoginSteps);
			}
		};
		window.addEventListener('popstate', handleBack);
		return () => {
			window.removeEventListener('popstate', handleBack);
		};
	}, [currentStep]);

	return (
		<>
			<div className={styles.questionMarkIcon}>
				<QuestionMarkIcon />
			</div>

			<div className='uteLoginHeader'>Recover&nbsp;or&nbsp;reset&nbsp;your&nbsp;email&nbsp;ID</div>
			<div className={styles.recoverOrResetText}>
				Please get in touch with {copmanyName} to recover your email ID.
				<br />
				<br />
				OR
				<br />
				<br />
				If you need to reset your email ID,
				<br />
				<span
					className={styles.clickHere}
					onClick={() => {
						setComponent('reset-email-id');
						setCurrentStep(LoginSteps.ResetEmail);
					}}>
					please click here.
				</span>
			</div>
		</>
	);
};

export default RecoverOrReset;
